<template>
  <h5 class="text-center">Certidões Locais</h5>
  <div class="alert alert-primary">
    <h6 class="mb-1">Informações:</h6>
    <ul v-html="certificateMessage" class="mb-0" />
  </div>
  <div v-if="documentsMessage" class="alert alert-warning">
    <h6 class="mb-1">Pontos de Atenção:</h6>
    <ul v-html="documentsMessage" class="mb-0" />
  </div>
  <div v-if="documentsExpireds.length > 0" class="alert alert-warning">
    <h6 class="mb-1">Certidões Expiradas:</h6>
    <ul class="mb-0">
      <li v-for="document in documentsExpireds" :key="document.id">
        {{ document.name }} ({{ dateTimeSqlToDateBR(document.expireAt) }})
      </li>
    </ul>
  </div>
  <div v-else class="alert alert-info">
    <h6 class="mb-1">Certidões Expiradas:</h6>
    <p>Não existem certidões expiradas.</p>
  </div>
  <div v-if="needJustify">
    <label class="form-label">
      Justificativa: <span class="text-danger">*</span>
    </label>
    <textarea
      class="form-control"
      rows="3"
      placeholder="Informe sua justificativa..."
      v-model="justifyCertificate"
    />
    <div class="text-end mt-3">
      <button
        class="btn btn-secondary rounded-pill"
        title="Prosseguir sem Certidão"
        @click="forwardProcess"
      >
        Prosseguir sem Certidão
      </button>
    </div>
  </div>

  <div v-else class="text-end">
    <button
      class="btn btn-secondary rounded-pill"
      title="Prosseguir"
      @click="forwardProcess"
    >
      Prosseguir
    </button>
  </div>
  <div class="col-12 mt-2">
    <div class="alert alert-warning border-0 alert-dismissible fade show">
      <span class="fw-semibold">Atenção!</span> Caso altere uma certidão,
      atualize a página para que a alteração seja refletida.
      <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
    </div>
  </div>
</template>

<script>
import { dateTimeSqlToDateBR } from '@/utils/date'

export default {
  name: 'ValidateCertificateLocal',

  props: {
    documents: {
      type: Array,
      required: true,
    },
    documentsExpireds: {
      type: Array,
      required: true,
    },
    requiredCertificates: {
      type: Boolean,
      required: true,
    },
  },

  emits: ['forwardCertificateValidationLocal'],

  data() {
    return {
      documentsTypes: [
        'CND MUNICIPAL',
        'CND ESTADUAL',
        'CND FGTS',
        'CND FEDERAL',
      ],
      certificateMessage: '',
      documentsMessage: '',
      needJustify: false,
      justifyCertificate: '',
      dateTimeSqlToDateBR,
    }
  },

  methods: {
    formatMessage() {
      if (this.requiredCertificates) {
        this.certificateMessage += '<li>Este contrato requer certidão</li>'
      }
      if (this.requiredCertificates && this.documents.length === 0) {
        this.needJustify = true
        this.certificateMessage +=
          '<li>Não existem certidões cadastradas para este contrato</li>'
      }
      if (this.requiredCertificates && this.documentsExpireds.length > 0) {
        this.needJustify = true
        this.certificateMessage +=
          '<li>Uma ou mais certidões estão vencidas</li>'
      }
      if (!this.needJustify) {
        this.certificateMessage +=
          '<li>Este contrato não requer certidão. Clique em "Prosseguir"'
      }

      const now = new Date()

      this.documentsTypes.forEach((documentType) => {
        const documentExists = this.documents.find(
          (document) => document.name === documentType,
        )

        if (documentExists) {
          const expireAtDate = new Date(documentExists.expireAt)
          if (now > expireAtDate && documentExists.isObsoleted === '0') {
            this.documentsMessage += `<li>O certificado ${documentType} está expirado</li>`
          }
        } else {
          this.documentsMessage += `<li>Não foi encontrado o certificado ${documentType}</li>`
        }
      })
    },

    forwardProcess() {
      if (this.needJustify && !this.justifyCertificate) {
        this.$root.$refs.notification.warning(
          'Por favor, informe uma justificativa.',
        )
        return
      }

      this.$emit('forwardCertificateValidationLocal', {
        needLocalCertificate: this.needJustify,
        justifyCertificate: this.justifyCertificate,
      })
    },
  },

  mounted() {
    this.formatMessage()
  },
}
</script>
